import type { OnboardingStep } from "@/api/onboarding";

/**
 * True for a step the browser onboarding owns. The desktop app starts its own
 * flow fresh from these; the browser leaves `desktop_*` steps to the desktop
 * app, since finishing them there would skip the desktop setup.
 */
export function isWebOnboardingStep(step: OnboardingStep): boolean {
  return (
    !step.startsWith("desktop_") && step !== "completed" && step !== "skipped"
  );
}
